import { render } from "./BAGiftQuiz.vue?vue&type=template&id=bdb5af8c&scoped=true"
import script from "./BAGiftQuiz.vue?vue&type=script&lang=js"
export * from "./BAGiftQuiz.vue?vue&type=script&lang=js"

import "./BAGiftQuiz.vue?vue&type=style&index=0&id=bdb5af8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb5af8c"]])

export default __exports__